import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Projects } from "../Data/Data";
import Section from "../components/Section";
import { getApartmentTypeByIds } from "../helpers/helpers";
import { ApartmentsTypes } from "../Data/ApartmentsTypes";
import LeftSide from "../components/ApartmentDetails/LeftSide";
import RightSide from "../components/ApartmentDetails/RightSide";
import Gallery from "../components/ApartmentDetails/Gallery";

const Flat = () => {
  const location = useLocation();
  const { floorId, id } = useParams();
  // console.log("floorId => ", floorId);
  // console.log("id => ", id);
  const currProject = useMemo(() => {
    const currProjectName = location.pathname.split("/")[2];
    const currProject = Projects.find(
      (project) => project.name === currProjectName
    );
    return currProject;
  }, [location.pathname]);

  const apartment = useMemo(() => {
    const currProjectName = location.pathname.split("/")[2];

    const currProject = Projects.find(
      (project) => project.name === currProjectName
    );
    //console.log("currProject => ", currProject);

    const findApartment = (apartmentNumber, floorNumber) => {
      for (const floor of currProject.floors) {
        const apartment = floor.apartmens.find(
          (apt) =>
            floor.floorNumber === Number(floorNumber) &&
            apt.number === Number(apartmentNumber)
        );
        if (apartment) {
          const { apartmentSubTypeObject, apartmentTypeObject } =
            getApartmentTypeByIds(
              apartment.typeId,
              apartment.subTypeId,
              ApartmentsTypes,
              currProject
            );
          return {
            ...apartment,
            projectName: currProject.name,
            projectAdress: currProject.address,
            floorNumber: floor.floorNumber,
            type: apartmentTypeObject,
            subType: apartmentSubTypeObject,
          };
        }
      }

      return null;
    };
    const apartment = findApartment(id, floorId);
    return apartment;
  }, [id, location.pathname, floorId]);

  // console.log(apartment);
  const apartmentRooms = useMemo(() => {
    const findRooms = (id) => {
      // console.log("id ", id);
      // console.log("apartment.type.subType ", apartment.type.subType);
      // const roomsObj = greenHomeApartmentsRoomsSizes.find(
      //   (apartment) => apartment.apartmentNumber === Number(id)
      // );

      // if (roomsObj) {
      //   return roomsObj.rooms;
      // } else {
      //   return [];
      // }
      const roomsObj = apartment.type.subType.find(
        (apartmentSubType) => apartmentSubType.id === id
      );
      // console.log(roomsObj);
      if (roomsObj) {
        return roomsObj.rooms;
      } else {
        return [];
      }
    };
    const rooms = findRooms(apartment.subTypeId);
    return rooms;
  }, [apartment.subTypeId, apartment.type.subType]);

  return (
    <>
      <Section bg={"bg-inherit"}>
        <h3 className="text-2xl xl:text-5xl font-bold uppercase tracking-widest text-primary-bg-blue col-start-2 col-span-10 my-12">
          {apartment.type.label}
        </h3>
        <main className="col-span-10 col-start-2 xl:grid grid-cols-1 xl:grid-cols-12 max-h-fit xl:mb-32 ">
          <LeftSide selectedProject={currProject} apartment={apartment} rooms={apartmentRooms} />
          <RightSide
            selectedProject={currProject}
            apartment={apartment}
            rooms={apartmentRooms}
          />
        </main>
      </Section>
      <Gallery imgList={apartment.subType.renders} />
    </>
  );
};

export default Flat;
